import * as Constants from "../common/constants";
import * as Global from "../common/global";
import { getURLParameters } from "../common/util";
import * as Util from "../common/util";
import * as AuthenticationData from "../data/authenticationData";
import { IController } from "../interfaces/controller";
import { IResponse } from "../interfaces/data";

// This is the page that the OnCue API will redirect to after
// a successful SAML login.
export class SAMLLoginController implements IController {
    public render(container: JQuery): JQuery.Promise<any, any, any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();

        deferred.resolve();
        return deferred.promise();
    }

    public load(params: any[]): JQueryPromise<any> {
        const deferred: JQuery.Deferred<any, any, any> = $.Deferred();
        const app = Global.app();
        const pageManager = app.pageManager();

        if (!params || params.length === 0) {
            // Authentication token not passed as the first parameter
            pageManager.closeAllAndGotoDefaultPage();
            deferred.resolve();
            return deferred.promise();
        }

        const authenticationToken = params[0];
        AuthenticationData.AuthenticateUserWithExternalToken({ Token: authenticationToken })
            .done((response: IResponse<AuthenticationData.IAuthenticateUserWithExternalTokenResponse>) => {
                if (response.Success && response.Payload.IsAuthenticated) {
                    // token is good, so login user
                    app.loginUser(response.Payload.AuthenticationToken, response.Payload.UserSession, response.Payload.ReportToken);
                    const queryStrings = getURLParameters();
                    if (queryStrings.length > 0) {
                        const query = this.buildUrlEndPoint(queryStrings);
                        this.useQueryAndNavigate(query);
                    }
                } else {
                    pageManager.closeAllAndGotoDefaultPage();
                }
            }).fail(() => {
                pageManager.closeAllAndGotoDefaultPage();
            });

        deferred.resolve();
        return deferred.promise();
    }

    public haveFieldsChanged(): boolean {
        // no editable fields
        return false;
    }

    public appRouterID(params: any[]): string {
        return "SAMLLogin";
    }

    public title(): string {
        return "External Login";
    }

    public subTitle(): string {
        return "";
    }

    public AllowAnonymousAccess(): boolean {
        return true;
    }

    // Private Methods
    private buildUrlEndPoint(queryStrings: Util.IKeyValuePair[]): string {
        let query = "";
        const pageToShow = queryStrings.filter((kvp) => kvp.Key === Constants.QUERYSTRING_PAGE_TO_SHOW);
        if (pageToShow.length > 0) {
            query += pageToShow[0].Value;
            if (queryStrings.length > 1) {
                for (const queryString of queryStrings) {
                    if (queryString !== pageToShow[0]) {
                        if (query.indexOf("?") < 0) {
                            query += `?${queryString.Key}=${queryString.Value}`;
                        } else {
                            query += `&${queryString.Key}=${queryString.Value}`;
                        }
                    }
                }
            }
        }
        return query;
    }

    private useQueryAndNavigate(query: string) {
        const pageManager = Global.app().pageManager();
        if (Util.isNullOrEmpty(query)) {
            pageManager.closeAllAndGotoDefaultPage();
        } else {
            pageManager.closeAllAndNavigate(query);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/controllers/samlLogin.ts